import { render, staticRenderFns } from "./SGoods.vue?vue&type=template&id=0dc6403f&scoped=true"
import script from "./SGoods.vue?vue&type=script&lang=js"
export * from "./SGoods.vue?vue&type=script&lang=js"
import style0 from "./SGoods.vue?vue&type=style&index=0&id=0dc6403f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc6403f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc6403f')) {
      api.createRecord('0dc6403f', component.options)
    } else {
      api.reload('0dc6403f', component.options)
    }
    module.hot.accept("./SGoods.vue?vue&type=template&id=0dc6403f&scoped=true", function () {
      api.rerender('0dc6403f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/modules/editor/modules/SGoods.vue"
export default component.exports